import SectionTitle from "@/components/base/SectionTitle";
import CategoryCard from "@/components/base/CategoryCard";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <SectionTitle
            title="Browse 14 Curated Categories"
            subtitle="Updated daily with fresh pandabuy spreadsheet finds"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <CategoryCard
              key={cat.name}
              name={cat.name}
              description={cat.description}
              link={cat.link}
              tag={cat.tag}
              image={cat.image}
            />
          ))}
        </div>

        <div className="flex justify-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-800 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Spreadsheet Items
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}